import { useState, useEffect } from 'react';

import { getBrowserWidth } from 'utils/responsive';

function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(getBrowserWidth());

  function handleWidthChange() {
    setWindowWidth(getBrowserWidth());
  }

  useEffect(() => {
    window.addEventListener('resize', handleWidthChange);
    return () => {
      window.removeEventListener('resize', handleWidthChange);
    };
  }, []);

  return windowWidth;
}

export { useWindowWidth };
